(() => {
  const create = (root, requestedId) => {
    const records = new Map();
    root.querySelectorAll('[data-lc-approved-designs] [data-lc-approved-design]').forEach(element => {
      const value = element.dataset;
      const width = Number(value.width), height = Number(value.height);
      if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value.designId || '') || value.designId.length > 64 || !['pvc', 'leatherette'].includes(value.material) || !Number.isFinite(width) || !Number.isFinite(height) || width < 0.5 || width > 5 || height < 0.5 || height > 5 || Math.abs(width * 100 - Math.round(width * 100)) > 0.00001 || Math.abs(height * 100 - Math.round(height * 100)) > 0.00001 || !value.reference || value.reference.length > 120 || records.has(value.designId)) return;
      records.set(value.designId, Object.freeze({ id: value.designId, name: value.designName || value.designId, material: value.material, width, height, reference: value.reference, shape: value.shape || '', notes: value.notes || '' }));
    });
    const form = root.querySelector('form');
    const fileInput = root.querySelector('[data-lc-artwork]');
    const upload = fileInput?.closest('.lc-custom__upload');
    const help = root.querySelector('.lc-custom__logo-help');
    const helpCallout = root.querySelector('.lc-custom__artwork-help');
    const libraryLink = root.querySelector('.lc-custom__saved-link');
    const widthInput = root.querySelector('[data-lc-width]');
    const heightInput = root.querySelector('[data-lc-height]');
    const quantityInput = root.querySelector('[data-lc-exact-quantity]');
    const materialInputs = [...root.querySelectorAll('[name="lc_material"]')];
    const logoInputs = [...root.querySelectorAll('[name="lc_logo_help"]')];
    const originalShape = root.querySelector('[name="properties[Patch shape]"]');
    const shapeDefault = originalShape?.value || 'Confirm with artwork';
    const message = root.querySelector('[data-lc-saved-artwork-message]');
    let current = null, banner = null, onChange = () => {};
    const properties = new Map();
    ['Approved design ID', 'Production reference', 'Artwork source'].forEach(key => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${key}]`;
      input.disabled = true;
      form.append(input);
      properties.set(key, input);
    });
    const clear = (notify = true) => {
      current = null;
      banner?.remove();
      banner = null;
      properties.forEach(input => { input.disabled = true; input.value = ''; });
      if (originalShape) originalShape.value = shapeDefault;
      if (fileInput) { fileInput.disabled = false; fileInput.required = true; }
      if (upload) upload.hidden = false;
      if (help) help.hidden = false;
      if (helpCallout) helpCallout.hidden = false;
      if (libraryLink) libraryLink.hidden = false;
      if (notify) onChange();
    };
    const matches = () => current && materialInputs.find(input => input.checked)?.value === current.material && Number(widthInput.value) === current.width && Number(heightInput.value) === current.height && logoInputs.find(input => input.checked)?.value === 'none';
    const sync = () => {
      if (current && !matches()) clear(false);
      return current;
    };
    const apply = () => {
      const record = records.get(requestedId || '');
      if (!record) {
        if (requestedId && message) message.hidden = false;
        return false;
      }
      current = record;
      materialInputs.forEach(input => { input.checked = input.value === record.material; });
      logoInputs.forEach(input => { input.checked = input.value === 'none'; });
      widthInput.value = record.width.toFixed(2);
      heightInput.value = record.height.toFixed(2);
      const minimum = record.material === 'leatherette' ? 12 : 50;
      if (quantityInput && (!Number.isInteger(Number(quantityInput.value)) || Number(quantityInput.value) < minimum)) quantityInput.value = String(minimum);
      const notes = root.querySelector('[name="properties[Patch size or shape notes]"]');
      if (notes) notes.value = record.notes;
      if (originalShape && record.shape) originalShape.value = record.shape;
      const values = { 'Approved design ID': record.id, 'Production reference': record.reference, 'Artwork source': 'Approved artwork on file' };
      properties.forEach((input, key) => { input.disabled = false; input.value = values[key]; });
      if (fileInput) { fileInput.value = ''; fileInput.disabled = true; fileInput.required = false; }
      if (upload) upload.hidden = true;
      if (help) help.hidden = true;
      if (helpCallout) helpCallout.hidden = true;
      if (libraryLink) libraryLink.hidden = true;
      const fragment = root.querySelector('[data-lc-saved-artwork-template]')?.content.cloneNode(true);
      banner = fragment?.querySelector('.lc-saved-artwork') || null;
      if (banner) {
        banner.querySelector('[data-lc-saved-artwork-name]').textContent = record.name;
        banner.querySelector('[data-lc-saved-artwork-clear]').addEventListener('click', () => clear());
        help?.before(banner);
      }
      if (message) message.hidden = true;
      root.dispatchEvent(new CustomEvent('lc:journey', { bubbles: true, detail: { event: 'approved_design_selected', journey: 'custom' } }));
      return true;
    };
    return Object.freeze({ apply, sync, clear, onChange(callback) { onChange = typeof callback === 'function' ? callback : () => {}; }, get active() { return matches() ? current : null; } });
  };
  window.LibertySavedDesigns = Object.freeze({ create });
})();
